import type { PayloadWithoutId } from '@components/ArtBoard/Comments/types'
import { LiteView } from '@octopus-do/octopus-editor'
import type React from 'react'
import { useState } from 'react'

import { useAuth } from '@/hooks'
import { Textarea } from '../../../CommentsForm/components/Textarea'
import { useCommitState } from './hooks'
import { parseEditorContent } from './utils'

type Props = {
  isEditing?: boolean
  onCancel: () => void
  onCommit: (payload: PayloadWithoutId) => Promise<void>
  value: string
}

const Content: React.FC<Props> = ({ isEditing, onCancel, onCommit, value }) => {
  const auth = useAuth()
  const [state, setState] = useState(parseEditorContent(value))

  const { error, handleCommit, loading } = useCommitState(onCommit)

  const onSubmit = () => {
    if (state.length === 0) {
      onCancel()
    }
    handleCommit(JSON.stringify(state))
  }

  if (!isEditing) {
    return <LiteView value={parseEditorContent(value)} key={Math.random()} />
  }

  return (
    <Textarea
      readonly={!auth.authenticated}
      error={error}
      value={state}
      loading={loading}
      onCancel={onCancel}
      onUpdate={setState}
      onSubmit={onSubmit}
      submitButtonText="Save"
    />
  )
}

export default Content
